/**
 * @file Job card component for job lists
 * Compatible with Deploy Z pipeline card structure:
 *   { id, name, phone, email, address, source, notes, amount, createdAt, customerId, ... }
 * Deploy Z uses "name" for customer name and may not have "customerName" or "desc".
 */

const STAGE_BADGES = {
  'New':                'badge-blue',
  'New Lead':           'badge-blue',
  'Contacted':          'badge-purple',
  'Quoted':             'badge-gold',
  'Proposal Sent':      'badge-orange',
  'Booked':             'badge-green',
  'Proposal Rejected':  'badge-red',
  'Accepted':           'badge-blue',
  'Scheduled':          'badge-purple',
  'In Progress':        'badge-gold',
  'Completed':          'badge-green',
  'Paid & Closed':      'badge-gray',
  'Paid':               'badge-gray',
};

/**
 * Render a job card HTML string.
 * @param {Object} job
 * @returns {string}
 */
export function renderJobCard(job) {
  const stageBadge = STAGE_BADGES[job.stage] || 'badge-gray';
  // Deploy Z cards: "name" is customer name; "desc" may or may not exist
  const name = job.customerName || job.name || 'Unknown';
  const desc = job.desc || job.source || '';
  const date = job.scheduledDate || job.createdAt || '';
  const dateStr = date ? formatDate(date) : '';
  const value = job.value || job.amount;
  const valueStr = value ? `$${Number(value).toLocaleString()}` : '';

  return `
    <div class="job-card" data-job-id="${job.id || ''}">
      <div class="job-card-info">
        <div class="job-card-name">${escHtml(name)}</div>
        ${desc ? `<div class="job-card-desc">${escHtml(desc)}</div>` : ''}
        <div class="job-card-meta">
          <span class="badge ${stageBadge}">${escHtml(job.stage || 'New')}</span>
          ${dateStr ? `<span class="job-card-date">${dateStr}</span>` : ''}
          ${valueStr ? `<span class="job-card-date">${valueStr}</span>` : ''}
        </div>
      </div>
      <span class="job-card-arrow">\u203A</span>
    </div>
  `;
}

function formatDate(d) {
  try {
    const date = new Date(d);
    if (isNaN(date.getTime())) return '';
    const today = new Date();
    if (date.toDateString() === today.toDateString()) return 'Today';
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (date.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch (e) { return ''; }
}

function escHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
